// Configuration for Admin Dashboard and Ads Control
export interface AdsConfig {
  Investments: boolean;
  Loans: boolean;
  Savings: boolean;
  Tax: boolean;
  Health: boolean;
  Dev: boolean;
  PDF: boolean;
  SEO: boolean;
  Productivity: boolean;
  Cryptography: boolean;
  'QR Labs': boolean;
  Other: boolean;
}

export const DEFAULT_ADS_CONFIG: AdsConfig = {
  Investments: true,
  Loans: true,
  Savings: true,
  Tax: true,
  Health: true,
  Dev: true,
  PDF: true,
  SEO: true,
  Productivity: true,
  Cryptography: true,
  'QR Labs': true,
  Other: true
};

export function getAdsConfig(): AdsConfig {
  if (typeof window === 'undefined') return DEFAULT_ADS_CONFIG;
  try {
    const saved = localStorage.getItem('utilix_ads_config');
    if (saved) {
      return { ...DEFAULT_ADS_CONFIG, ...JSON.parse(saved) };
    }
  } catch (e) {
    console.error('Error parsing ads config', e);
  }
  return DEFAULT_ADS_CONFIG;
}

export function saveAdsConfig(config: AdsConfig) {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem('utilix_ads_config', JSON.stringify(config));
    // Trigger window event for active observers
    window.dispatchEvent(new Event('utilix-ads-config-changed'));
  } catch (e) {
    console.error('Error saving ads config', e);
  }
}

export function getCurrentSilo(): keyof AdsConfig {
  if (typeof window === 'undefined') return 'Other';
  const path = window.location.pathname;
  if (path.includes('/finance/investments')) return 'Investments';
  if (path.includes('/finance/loans')) return 'Loans';
  if (path.includes('/finance/savings')) return 'Savings';
  if (path.includes('/finance/tax')) return 'Tax';
  if (path.includes('/health')) return 'Health';
  if (path.includes('/developer')) return 'Dev';
  if (path.includes('/pdf')) return 'PDF';
  if (path.includes('/seo')) return 'SEO';
  if (path.includes('/pro-hub') || path.includes('/productivity')) return 'Productivity';
  if (path.includes('/cryptography')) return 'Cryptography';
  if (path.includes('/qr')) return 'QR Labs';
  return 'Other';
}

export function isAdEnabledForCurrentPage(): boolean {
  const silo = getCurrentSilo();
  const config = getAdsConfig();
  return config[silo] !== false;
}

export function getFileOverride(filename: 'tax-slab.json' | 'currency-rates.json'): string {
  if (typeof window === 'undefined') return '';
  const key = filename === 'tax-slab.json' ? 'utilix_override_tax_slab' : 'utilix_override_currency_rates';
  return localStorage.getItem(key) || '';
}

export function saveFileOverride(filename: 'tax-slab.json' | 'currency-rates.json', content: string): boolean {
  if (typeof window === 'undefined') return false;
  try {
    // Validate JSON structure first
    JSON.parse(content);
    const key = filename === 'tax-slab.json' ? 'utilix_override_tax_slab' : 'utilix_override_currency_rates';
    localStorage.setItem(key, content);
    window.dispatchEvent(new CustomEvent('utilix-file-override-changed', { detail: { filename } }));
    return true;
  } catch (e) {
    return false;
  }
}

